<ng-container *ngIf="!popOver;else popOverT">
  <color-sketch [presetColors] ="colors" [color]="color" (onChangeComplete)="handleChangeComplete($event)"></color-sketch>
</ng-container>
<ng-template #popOverT>
  <div class="input-cell">
    <div class="input-wrapper-row key-value">
        <div class="input-label">Current:</div>
        <div class="current-value" [ngStyle]="{'background': color}"></div>
        <button 
          nbButton 
          class="icon-action" 
          status="primary" 
          size="small"
          [nbPopover]="component"
          [nbPopoverContext]="{color:color,colors:fillColors,target:target,property:property}" nbPopoverPlacement="right">
            <nb-icon icon="fill-color" pack="custom-icons" size="medium"></nb-icon>
        </button>
    </div>
</div>
<!-- <div class="input-cell">
    <div class="input-wrapper-row">
        <nb-radio-group [(value)]="selectedOption" (valueChange)="onChangeOption($event)" #optionPicker>
            <nb-radio value="preset">Presets</nb-radio>
            <nb-radio value="custom">Custom</nb-radio>
        </nb-radio-group>
    </div>
    <div class="selected-color-picker">
        <color-sketch [presetColors] ="fillColors" [color]="color" (onChangeComplete)="handleChangeComplete($event)" (onChange)="handleColorPick($event)" #primaryColorPicker kveToggleSection></color-sketch>
    </div>
</div> -->
</ng-template>


<!-- <color-compact-color
          *ngFor="let color of colors"
          [active]="color"
          (onClick)="handleBlockChange($event)"
        ></color-compact-color> -->

        <!-- <color-compact [color]="state" (onChangeComplete)="changeComplete($event)" (onChange)="changeComplete($event)"></color-compact> -->
